import {} from '@reown/appkit-common';
import { solana, solanaDevnet, solanaTestnet } from '@reown/appkit/networks';
export const solanaChains = {
    'solana:mainnet': solana,
    'solana:testnet': solanaTestnet,
    'solana:devnet': solanaDevnet
};
//# sourceMappingURL=chains.js.map